<template>
  <input
    type="text"
    class="form-control"
    :value="currentSerialNumber"
    @input="inputSerialNumber"
    :placeholder="currentSerialNumber ? currentSerialNumber : $t('src/pages/devices.enterSeriesNumber')"
  />
</template>

<script>
import http from '@/modules/http.js'
import debounce from 'debounce'
import { stringify } from 'qs'

export default {
  name: 'DeviceFilter',
  props: {
    deviceNumber: {
      type: String,
      required: false
    }
  },
  data: () => ({
    devices: null,
    currentSerialNumber: null
  }),
  created() {
    this.inputSerialNumber = debounce(this.inputSerialNumber, 500)
    this.currentSerialNumber = this.deviceNumber
    this.loadData().then(devices => {
      this.devices = devices
    })
  },
  watch: {
    device() {
      if (this.device.length === 0) {
        this.currentSerialNumber = null
      }
    },
    deviceNumber() {
      this.currentSerialNumber = this.deviceNumber
      if (!this.currentSerialNumber) {
        this.devices = null
      }
    }
  },
  computed: {
    params() {
      let params = {
        $select: ['id', 'serial_number']
      }
      if (this.currentSerialNumber) {
        params['serial_number'] = {
          $like: `%${this.currentSerialNumber}%`
        }
      }
      return params
    }
  },
  methods: {
    inputSerialNumber(e) {
      this.currentSerialNumber = e.target.value
      if (this.currentSerialNumber !== '') {
        this.loadData().then(devices => {
          if (devices.length > 0) {
            this.devices = devices
            this.$emit('input:Number', this.devices, this.currentSerialNumber)
          } else {
            this.$emit('input:Number', [{ id: this.currentSerialNumber }], this.currentSerialNumber)
          }
        })
      } else this.$emit('input:Number', null, null)
    },
    loadData() {
      return new Promise(resolve => {
        http
          .get('/devices', {
            params: this.params,
            paramsSerializer: params =>
              stringify(params, {
                arrayFormat: 'indices',
                encodeValuesOnly: true
              })
          })
          .then(response => response.data.data)
          .then(devices => {
            resolve(devices)
          })
          .catch(error => {
            console.error(error)
          })
      })
    }
  }
}
</script>
